import { formatRmStringToNumber } from 'util/formatters/numberFormatter';
import { filter, get, inRange } from 'lodash';

export const parseSearchResults = ({ searchResults, rmMax, rmMin }) => {
  rmMax = parseFloat(rmMax);
  rmMin = parseFloat(rmMin);

  const extendedResults = searchResults.map((result) => {
    // this is for some RMs that are weird formats like 00.7
    // we want to display the weird format,
    // while being able to sort with a non-string
    const originalRm = get(result, 'rm.q', 0);
    result.displayRm = originalRm;
    result.rm = formatRmStringToNumber(originalRm);
    return result;
  });
  return filter(extendedResults, (result) => {
    return inRange(result.rm, rmMin, rmMax) || result.rm===rmMax; // lodash inRange is not inclusive of the upper bound
  });
};
